module.exports = __webpack_public_path__ + "img/transdev.0cb200ae.webp";